import vList from './List.vue';
import vListItem from './ListItem.vue';

export { vList, vListItem }


// WEBPACK FOOTER //
// ./src/baseComponents/components/List/index.js